
import { Component, Mixins } from "vue-property-decorator";
import { IObjectsControllable, ILinkedObjectGroupSpecifiable } from "../../../../../../documaker/domain/format/objects";
import { IGroupAlertAllowBehaviorPropertyEditable, instanceOfIGroupAlertAllowBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class GroupAlertAllowBehaviorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IGroupAlertAllowBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IGroupAlertAllowBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isGroupAlertAllowBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIGroupAlertAllowBehaviorPropertyEditable(s) && s.groupAlertAllowBehavior().isEditable(), false);
  }

  get groupAlertAllowBehavior(): IObjectsControllable<ILinkedObjectGroupSpecifiable> {
    return this.readPropertyOrDefault(s => s.groupAlertAllowBehavior().getValue(), { targets: [] });
  }

  set groupAlertAllowBehavior(value: IObjectsControllable<ILinkedObjectGroupSpecifiable>) {
    this.writePropertyWhenValid(s => s.groupAlertAllowBehavior().setValue(value));
  }
}
